import { z } from 'zod/v4';

/**
 * The line widget's structured **styles** group — the data carried by the
 * envelope's `styles` field. Like the image widget (and unlike every other
 * widget, whose `styles` is the open JSS `styleBagSchema` record), the divider
 * persists a typed bag here: the `<hr>`'s top border plus its width and the
 * wrapper margin.
 *
 * `width` is a PERCENTAGE of the column (0–100), not pixels — it and
 * `borderTopWidth` (px) are the two numbers the control panel edits.
 */
export const LINE_SIZE_BOUNDS = { min: 0, max: 100 } as const;

export const lineStylesSchemaLegacy = z.object({
    borderTopColor: z.string(),
    borderTopWidth: z.number().meta(LINE_SIZE_BOUNDS),
    borderTopStyle: z.enum(['solid', 'dashed', 'dotted']),
    width: z.number().meta(LINE_SIZE_BOUNDS),
    /** Wrapper margin shorthand — seeded `'0 auto'`, never edited in the UI. */
    margin: z.string().nullish(),
});

export type LineStylesLegacy = z.infer<typeof lineStylesSchemaLegacy>;

/** Default styles bag — the source of the host `line.model.ts` defaults. */
export const createLineStylesLegacy = (overrides: Partial<LineStylesLegacy> = {}): LineStylesLegacy => ({
    borderTopColor: '#bcc8c8',
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    width: 100,
    margin: '0 auto',
    ...overrides,
});
